export default __webpack_public_path__ + "static/media/YAS0930.34I-42407_-25401_0.2d1221d9.jpg";